export default __webpack_public_path__ + "../img/65fa90e4a15f92c3ce9ca5cfe267d7d6.png";